import { Component, OnInit } from '@angular/core';
import { Produto } from 'src/app/model/produto';
import { ToastService } from 'src/app/core/toast.service';
import { AlertService } from 'src/app/core/alert.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { GlobalService } from 'src/app/dao/global.service';
import { SelectItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';

@Component({
  selector: 'app-ativacaoopccomp',
  templateUrl: './ativacaoopccomp.page.html',
  styleUrls: ['./ativacaoopccomp.page.scss'],
})
export class AtivacaoopccompPage implements OnInit {



  categorias = [];

  categoriasAux = [];

  categoriasNomesAux = [];

  formCatId;
   // tslint:disable-next-line: max-line-length
  constructor(private apiOpcs: ApiGruposopcionaisService, private router: Router, private route: ActivatedRoute, private toast: ToastService, private apiproduto: ApiGruposopcionaisService) { }

  ngOnInit() {
    this.loadCategorias();

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      // tslint:disable-next-line: radix
    }
  }

  ionViewWillEnter() {
    this.loadCategorias();
  }





  async onSubmit2(idCat) {
    try {
      this.formCatId = idCat;
      this.router.navigate(['/opcgrupo-list/', this.formCatId]);
    } catch (error) {
      this.toast.showError('Ocorreu um erro');
      console.log(error);
    }

  }


  async loadCategorias() {
    this.apiproduto.GetGruposList().then(async res => {
      this.categoriasAux = res;

      

      await this.apiOpcs.listarTodosNomes().then(res => {
        console.log('API resultado:', res);
    
        // Faz merge dos grupos fixos com os nomes retornados do banco
        this.categoriasNomesAux  = this.categoriasAux.map(grupo => {
          const encontrado = res.find(item => item.grupo === grupo.code);
          console.log(encontrado);
          return {
            grupo: grupo.code,
            nome: encontrado ? encontrado.nome : grupo.name
          };
        });

        console.log('Resultado final:', this.categoriasNomesAux);
      }).catch(err => {
        console.error('Erro ao obter Opcionais', err);
        this.toast.showError('Erro ao obter Opcionais');
      });


    
        this.categoriasAux.forEach(cat => {
          const correspondente = this.categoriasNomesAux.find(nome => nome.grupo === cat.code);
          if (correspondente) {
            cat.name = correspondente.nome;
          }
        });


      //this.toast.showSucess('Categorias obtidas com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Categorias');
    });
  }

  async loadCategorias2() {

      this.categoriasAux = [
      {name: 'Grupo 1', code: 'grupo1'},
      {name: 'Grupo 2', code: 'grupo2'},
      {name: 'Grupo 3', code: 'grupo3'},
      {name: 'Grupo 4', code: 'grupo4'},

      {name: 'Bordas', code: 'borda'},
      {name: 'Massas', code: 'massa'},
      {name: 'Bebidas', code: 'bebida'},
      {name: 'Misturas', code: 'misturas'},
      {name: 'Grupo Extra', code: 'grupoExtra'},
      
      {name: 'Grupo 5', code: 'grupo5'},
      {name: 'Grupo 6', code: 'grupo6'},
      {name: 'Grupo 7', code: 'grupo7'},
      {name: 'Grupo 8', code: 'grupo8'},
      {name: 'Grupo 9', code: 'grupo9'},
      {name: 'Grupo 10', code: 'grupo10'},
      {name: 'Grupo 11', code: 'grupo11'},
      {name: 'Grupo 12', code: 'grupo12'},
      {name: 'Grupo 13', code: 'grupo13'},
      {name: 'Grupo 14', code: 'grupo14'},
      {name: 'Grupo 15', code: 'grupo15'},
      {name: 'Grupo 16', code: 'grupo16'},
      {name: 'Grupo 17', code: 'grupo17'},
      {name: 'Grupo 18', code: 'grupo18'},
      {name: 'Grupo 19', code: 'grupo19'},
      {name: 'Grupo 20', code: 'grupo20'},
      {name: 'Grupo 21', code: 'grupo21'},
      {name: 'Grupo 22', code: 'grupo22'},
      {name: 'Grupo 23', code: 'grupo23'},
      {name: 'Grupo 24', code: 'grupo24'},
      {name: 'Grupo 25', code: 'grupo25'},
  ];




  console.log(this.categoriasAux);
}
  
}
